import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn";
import GenericColumn from '@isceco/widget-library2/basic-elements/List/column/GenericColumn.js';
import DateTimeCell from '@isceco/widget-library2/basic-elements/List/cell/DateTimeCell.js';

export default class MonitoringColumns {

  static getColumns() {
    return [
      MonitoringColumns.TIME_COLUMN(),
      MonitoringColumns.FORMULAR(),
      MonitoringColumns.EMAIL(),
      MonitoringColumns.SEDEX_ID(),
      MonitoringColumns.STATUS(),
      MonitoringColumns.REMARKS(),
    ]
  }

  static TIME_COLUMN() {
    return new GenericColumn({
      key: 'timestamp',
      text: 'table.header.monitoring.submission.time',
      cell: new DateTimeCell(),
      weight: 0.5,
      sortable: true
    })
  }

  static FORMULAR() {
    return new StringColumn({
      key: 'submittedFormName',
      text: 'table.header.monitoring.submitted.form',
      sortable: true
    })
  }

  static EMAIL() {
    return new StringColumn({
      key: 'email',
      text: 'table.header.monitoring.email',
      sortable: true
    })
  }

  static SEDEX_ID() {
    return new StringColumn({
      key: 'formUuid',
      text: 'table.header.monitoring.form.uuid',
      sortable: true
    })
  }

  static STATUS() {
    return new StringColumn({
      key: 'status',
      text: 'table.header.monitoring.status',
      weight: 0.5,
      sortable: true
    })
  }

  static REMARKS() {
    return new StringColumn({
      key: 'remarks',
      text: 'table.header.monitoring.remarks',
      sortable: true
    })
  }
}

